import { pickOrganizedTourDealSpread } from "./pickOrganizedTourDealSpread";
import {
  organizedTourImageUrlLooksLowRes,
} from "./organizedTourHeroImageSsot";

function firstNonEmptyUrl(...candidates) {
  for (const c of candidates) {
    if (c == null) continue;
    const t = String(c).trim();
    if (t && (t.startsWith("http://") || t.startsWith("https://") || t.startsWith("//"))) {
      return t;
    }
  }
  return "";
}

function firstHotelPictureUrl(hotel) {
  if (!hotel || typeof hotel !== "object") return "";
  const direct = firstNonEmptyUrl(
    hotel.mainPicture,
    hotel.pictureUrl,
    hotel.heroImageUrl,
    hotel.imageUrl,
    hotel.thumbnailUrl
  );
  if (direct) return direct;
  const hp = hotel.hotelPictures;
  let list = [];
  if (Array.isArray(hp)) list = hp;
  else if (hp && typeof hp === "object") {
    list = hp.picture || hp.url || hp.item || [];
    if (!Array.isArray(list)) list = [list];
  }
  for (const item of list) {
    const u =
      typeof item === "string"
        ? item
        : firstNonEmptyUrl(item?.url, item?.src, item?.pictureUrl);
    if (u) return u;
  }
  return "";
}

/**
 * SSOT for organized-tour card hero (tour resource + hotel shots + order snapshot).
 * @param {unknown} deal
 * @returns {{ resolvedImage: string, imageSource: string, fallbackUsed: boolean }}
 */
export function resolveOrganizedTourCardImage(deal) {
  const root = pickOrganizedTourDealSpread(deal);
  const tour = root.tour || {};
  const resource = tour.resource && typeof tour.resource === "object" ? tour.resource : {};
  const hotelHero = firstHotelPictureUrl(root.hotel);

  const pairs = [
    ["tour.resourceUrl", tour.resourceUrl],
    ["tour.resource.resourceUrl", resource.resourceUrl],
    ["hotel.picture", hotelHero],
    ["deal.resourceUrl", root.resourceUrl],
    ["reservation.tour.imageUrl", root.order_response?.reservation?.tour?.imageUrl],
    ["reservation.tour.resourceUrl", root.order_response?.reservation?.tour?.resourceUrl],
  ];

  for (const [source, url] of pairs) {
    const resolved = typeof url === "string" ? firstNonEmptyUrl(url) : "";
    if (!resolved) continue;
    if (
      source === "hotel.picture" &&
      organizedTourImageUrlLooksLowRes(resolved)
    ) {
      if (import.meta.env?.DEV) {
        console.log("[ORG_TOUR_IMAGE_LOW_QUALITY_BLOCKED]", {
          source,
          skipped: true,
          reason: "thumbnail_like_hotel_image",
          urlSample: resolved.slice(0, 140),
        });
      }
      continue;
    }
    if (
      import.meta.env?.DEV &&
      organizedTourImageUrlLooksLowRes(resolved) &&
      !String(source).startsWith("tour.resource")
    ) {
      console.log("[ORG_TOUR_IMAGE_LOW_QUALITY_BLOCKED]", {
        source,
        hint: "low_res_detected_but_used",
        urlSample: resolved.slice(0, 140),
      });
    }
    return { resolvedImage: resolved, imageSource: source, fallbackUsed: false };
  }

  return { resolvedImage: "", imageSource: "none", fallbackUsed: true };
}

export function traceOrganizedTourCardImage(dealId, payload) {
  if (!import.meta.env?.DEV) return;
  console.log("[ORG_TOUR_IMAGE_TRACE]", { dealId, ...payload });
}
